import { IErrorWithSentryId } from 'interfaces/IErrorWithSentryId';

const errosPorRequest = [
  {
    nomeRequest: 'getEmitirGru',
    errors: [
      {
        httpStatus: 500,
        mensagemErroTratada:
          'Erro ao emitir a Guia de Recolhimento - Indisponibilidade do serviço de pagamento, tente novamente mais tarde.',
      },
      {
        httpStatus: 422,
        mensagemErroTratada:
          'Erro ao emitir a Guia de Recolhimento - Valores inválidos, favor verificar os valores preenchidos na Guia de Recolhimento.',
      },
    ],
  },
  {
    nomeRequest: 'exportarGuiasCSV',
    errors: [
      {
        httpStatus: 404,
        mensagemErroTratada:
          'O arquivo não foi gerado pois não há guias que atendam aos filtros marcados, favor corrigí-los.',
      },
    ],
  },
  {
    nomeRequest: 'exportarGuiasExcel',
    errors: [
      {
        httpStatus: 404,
        mensagemErroTratada:
          'O arquivo não foi gerado pois não há guias que atendam aos filtros marcados, favor corrigí-los.',
      },
    ],
  },
];

export function tratarMensagemErro(nomeRequest: string, error: IErrorWithSentryId, mensagemGenerica: string = '') {
  const itemRequest = errosPorRequest.find((item) => item.nomeRequest == nomeRequest);
  const erroEspecifico = itemRequest?.errors.find((err) => err.httpStatus == error.status);

  return erroEspecifico?.mensagemErroTratada || mensagemGenerica + (error.message || '');
}
